<template>
  <div class="career-app">
    <table>
      <thead>
      <tr>
        <th>{{ translations?.title }}</th>
        <th>{{ translations?.location }}</th>
        <th :aria-sort="sortAsc ? 'ascending' : 'descending'">
          <button
            @click="sortByDeadline">
            {{ translations?.deadline }}
              <span v-if="sortAsc">↑</span>
              <span v-else>↓</span>
          </button>
        </th>
      </tr>
      </thead>
      <tbody>
      <template v-if="jobs.length > 0">
        <tr v-for="job in jobs" :key="job.title">
          <td>
            <a v-if="!!job.link" :href="job.link" target="_blank" rel="noopener noreferrer">
              {{ job.title }}
            </a>
            <span v-else>
              {{ job.title }}
            </span>
          </td>
          <td>{{ job.location }}</td>
          <td>{{ job.deadline }}</td>
        </tr>
      </template>
      <tr v-else>
        <td colspan="3">{{ translations?.noJobsMessage }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import {useApi} from '@util/api-service';
import {onBeforeMount, ref} from "vue";
import {IJobs} from "@features/Components/CareerBlock/Scripts/App/interfaces/IJobs";
import {ICareerResponse} from "@features/Components/CareerBlock/Scripts/App/interfaces/ICareerBlockResponse";
import {ITranslations} from "@features/Components/CareerBlock/Scripts/App/interfaces/ITranslations";

const {get} = useApi(`/career`);
const jobs = ref<IJobs[]>([])
const translations = ref<ITranslations>();
const sortAsc = ref(true);

onBeforeMount(() => {
  get<ICareerResponse>().then((response: ICareerResponse) => {
    jobs.value = response.jobs;
    translations.value = response.translations;
  });
});

function sortByDeadline() {
  jobs.value.sort((a, b) => {
    const dateA = new Date(a.deadline).getTime();
    const dateB = new Date(b.deadline).getTime();
    return sortAsc.value ? dateA - dateB : dateB - dateA;
  });
  sortAsc.value = !sortAsc.value;
}

</script>